import * as React from 'react';

import { View } from '@/core';
import styles from './style';

interface Props {
	reservationStart: number;
	reservationWidth: number;
	type: string;
}

export const Reservation: React.FC<Props> = ({ reservationStart, reservationWidth, type }) => {
	return (
		<View
			style={[
				styles.reservation,
				styles[`${type}Reservation`],
				{ left: reservationStart, width: reservationWidth },
			]}
		/>
	);
};
